import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective } from 'ngx-mask';
import Swal from 'sweetalert2';
import { RestClientService } from '../../../../core/service/rest-client.service';
import { AuthService } from '../../../../core/service/auth.service';
import { UtilitiesService } from '../../../../core/service/utilities.service';
import { MoneyFormatPipe } from '../../../../shared/pipe/money-format.pipe';
import { BenefInfoComponent } from '@shared/components/benef-info/benef-info.component';
import { MatDialog } from '@angular/material/dialog';
import { SearchMdicamentProComponent } from '@shared/components/search-mdicament-pro/search-mdicament-pro.component';
import { ViewEncapsulation } from '@angular/core';
import { IntegerFormatPipe } from '../../../../shared/pipe/integer-format.pipe';
import { SearchFormComponent } from '@shared/components/search-form/search-form.component';
import { PrescriptionActeChatDialogComponent } from '@shared/components/prescription-acte-chat-dialog/prescription-acte-chat-dialog.component';
import { FormPresProcreaComponent } from '../form-pres-procrea/form-pres-procrea.component';

@Component({
  selector: 'app-form-exec-procrea',
  imports: [
    MoneyFormatPipe,
    CommonModule,
    NgSelectModule,
    NgxMaskDirective,
    BenefInfoComponent,
    FormsModule,
    SearchMdicamentProComponent,
    IntegerFormatPipe,
    SearchFormComponent,
    PrescriptionActeChatDialogComponent,
    FormPresProcreaComponent,
  ],
  templateUrl: './form-exec-procrea.component.html',
  styleUrl: './form-exec-procrea.component.scss',
})
export class FormExecProcreaComponent {
  groupedItemsMedicament: { [key: string]: any[] } = {};
  groupedItemsPrescription: { [key: string]: any[] } = {};
  selectedTab = 'tab1';
  showPresModal = false;
  @Output() onSendBenefItem = new EventEmitter<any>();
  @Output() onClosePrescriptionMedocModal = new EventEmitter<any>();
  @Output() onGoToTab = new EventEmitter<any>();
  @Input() matricule: any;
  @Input() refreshPharmacieComponent: any;
  isNormalMode = true;

  current_medicament_id: any = '';
  reload = false;
  produit: string = '';
  clearText = false;
  posologie: string = '';
  frequence: string = '';
  renouvellement: string = '';
  quantite: number = 1;
  items: any = [];
  selectedMedoc: any = {};
  itemsPrescription: any = [];
  itemsPrescriptionAservir: any = [];

  isLoading: boolean | undefined;
  isLoadingRenew: boolean | undefined;
  input_value: any;
  input_option = 'MAT';
  searchPlaceHolder = 'Entrez numéro matricule';

  user: any = {};
  isConsultationSuccess = false;
  itemConsultation: any = {};
  itemToAdd: any = {};
  beneficiaireAutOselect: any;

  itemToSave: any = {};
  itemsModePrescription = [
    { code: 'produit', libelle: 'Produit' },
    { code: 'molecule', libelle: 'Molécule' },
  ];
  itemBeneficiare: any = {};
  fileName1: any;
  currentFile: any;
  itemsAffection: any;
  cancelItemSelected: boolean = false;
  medocOriginal: any;
  showModal: boolean = false;
  isLoadingCommande: boolean = false;
  itemsGarantie: any = [];
  itemTarifActe: any = {};
  constructor(
    private restClient: RestClientService,
    private router: Router,
    private authService: AuthService,
    private utilities: UtilitiesService,
    private dialogModel: MatDialog,
  ) {
    this.user = this.authService.getCurrentUser();
    console.log('connected user: ', this.user);
    this.itemToAdd = { quantite: 1 };
    this.itemToSave.mode_prescription = 'produit';
    // this.getItemsAffection()
    this.itemToSave.date_prescription = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1, // getMonth() returns 0-11
      day: new Date().getDate(),
    };
    this.itemsPrescription = [];
    let activeBeneficiaire = this.authService.getActiveBeneficiaire();
    if (activeBeneficiaire.matricule) {
      this.searcheBenef(activeBeneficiaire.matricule);
    }
    this.beneficiaireAutOselect = this.authService.getActiveBeneficiaire();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['refreshPharmacieComponent'] &&
      changes['refreshPharmacieComponent'].currentValue
    ) {
      let activeBeneficiaire = this.authService.getActiveBeneficiaire();
      if (activeBeneficiaire.matricule) {
        this.searcheBenef(activeBeneficiaire.matricule);
      }
    }
  }

  getItemsAffection() {
    let request = {
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient.post('affection/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsAffection = res.items;
          console.log('this.itemsAffection: ', this.itemsAffection);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsAffection = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsAffection = [];
      },
    );
  }

  onSelectTab(tab: string) {
    this.selectedTab = tab;
  }
  calculateTotalPartiel(item: any) {
    if (item.quantite_pharmacie && item.quantite_pharmacie != item.quantite) {
      this.utilities.showSweetNotification(
        'La quantité servie doit etre égale à la quantité servie',
        'error',
      );
      item.quantite_pharmacie = 0;
      return;
    }
    // if (item.quantite_pharmacie && item.quantite_pharmacie > item.quantite) {
    //   this.utilities.showSweetNotification(
    //     'Quantité approuvée dépassée.Maximum: ' + item.quantite,
    //     'error'
    //   );
    //   item.quantite_pharmacie = 0
    //   return
    // }
    if (
      this.isGreaterThanNPercentAbove(
        item.prix_systeme,
        item.prix_pharmacie,
        10,
      )
    ) {
      let maximum = this.getThreshold(item.prix_systeme, 10);
      this.utilities.showSweetNotification(
        'Montant approuvée dépassé.Maximum: ' + maximum,
        'error',
      );
      item.prix_pharmacie = 0;
      return;
    }

    if (item.prix_pharmacie && item.quantite_pharmacie) {
      item.montant = item.prix_pharmacie * item.quantite_pharmacie;

      item.part_assurance =
        (this.itemBeneficiare.taux_applicable / 100) * item.montant;
      item.part_patient =
        ((100 - this.itemBeneficiare.taux_applicable) / 100) * item.montant;
    }
  }

  isGreaterThanNPercentAbove(number1: any, number2: any, n: any) {
    const threshold = number1 + (n / 100) * number1;
    return number2 > threshold;
  }

  getThreshold(number1: any, n: any) {
    return number1 + (n / 100) * number1;
  }

  getTotal() {
    let total = 0;
    if (this.itemsPrescriptionAservir && this.itemsPrescriptionAservir.length) {
      this.itemsPrescriptionAservir.forEach((ima: any) => {
        const value = Number(ima.montant);
        if (!isNaN(value)) {
          total += value;
        }
      });
    }
    return total;
  }

  getTotalPartPatient() {
    let total = 0;
    if (this.itemsPrescriptionAservir && this.itemsPrescriptionAservir.length) {
      this.itemsPrescriptionAservir.forEach((ima: any) => {
        const value = Number(ima.part_patient);
        if (!isNaN(value)) {
          total += value;
        }
      });
    }
    return total;
  }
  getTotalDepassement() {
    let total = 0;
    if (this.itemsPrescriptionAservir && this.itemsPrescriptionAservir.length) {
      this.itemsPrescriptionAservir.forEach((ima: any) => {
        const value = Number(ima.depassement);
        if (!isNaN(value)) {
          total += value;
        }
      });
    }
    return total;
  }

  getTotalPartAssurance() {
    let total = 0;
    if (this.itemsPrescriptionAservir && this.itemsPrescriptionAservir.length) {
      this.itemsPrescriptionAservir.forEach((ima: any) => {
        const value = Number(ima.part_assurance);
        if (!isNaN(value)) {
          total += value;
        }
      });
    }
    return total;
  }

  onChangeInputMode() {
    this.input_value = '';
    this.searchPlaceHolder =
      this.input_option == 'MAT'
        ? 'Entrez numéro matricule'
        : 'Entrez numéro cnam';
  }

  searcheBenef(activeBenefMatricule?: any) {
    if (!this.input_value && activeBenefMatricule) {
      this.input_value = activeBenefMatricule;
    }
    this.isLoading = false;
    this.isConsultationSuccess = false;
    let mat_form = {
      matricule: this.input_value,
    };

    this.itemBeneficiare = {};
    this.itemConsultation = {};

    let cmu_form = {
      numero_cnam: this.input_value,
    };
    if (!this.input_value) {
      const messages: { [key: string]: string } = {
        CMU: 'Veuillez reseigner numéro CMU',
        MAT: 'Veuillez reseigner numéro matricule',
      };

      const message = messages[this.input_option];

      if (message) {
        this.utilities.showSweetNotification(message, 'error');
        this.isLoading = false;
        return;
      }
    }

    let request = {
      // user_id:this.user.id,
      data: this.input_option == 'CMU' ? cmu_form : mat_form,
    };

    this.isLoading = true;

    this.restClient.post('beneficiaire/search', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError']) {
          this.itemBeneficiare = res.item;
          this.authService.setActiveBeneficiaire(res.item);
          this.getItemsGarantie();

          this.onSendBenefItem.emit(this.itemBeneficiare);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemBeneficiare = {};
        }
      },
      (error) => {
        this.isLoading = false;
        this.utilities.showSweetNotification(error, 'error');
        this.itemBeneficiare = {};
      },
    );
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];

      console.info('fileName', fileName);
      console.info('extension', extension);
      this.fileName1 = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        // this.imageDisplay = data;
        const fileBase64 = data.split(',')[1];
        this.currentFile = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: 'custom type',
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  onGetDossiers() {}

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }

  confirmSaveItem(data: any) {
    // item.specialiteId = this.selectedSpecialite.id
    // if (!data || !data.affection_id) {
    //   this.utilities.showSweetNotification('Veuillez renseigner affection', 'error');
    //   return;
    // }
    // if (!data || !data.date_prescription) {
    //   this.utilities.showSweetNotification('Veuillez renseigner date prescription', 'error');
    //   return;
    // }
    // if (!data || !data.affection_id) {
    //   this.utilities.showSweetNotification('Veuillez renseigner affection', 'error');
    //   return;
    // }
    // if (!data || !data.mode_prescription) {
    //   this.utilities.showSweetNotification('Veuillez renseigner mode prescription', 'error');
    //   return;
    // }

    if (
      !this.itemsPrescriptionAservir ||
      !this.itemsPrescriptionAservir.length
    ) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner au moin un medicament',
        'error',
      );
      return;
    }

    // let medicament_non_traite = this.itemsPrescriptionAservir.filter((ima: any) => {
    //   return !ima.is_entente_prealable && !ima.is_exclu && !ima.prix_pharmacie && !ima.quantite_pharmacie
    // })

    // if (medicament_non_traite.length) {
    //   this.utilities.showSweetNotification(
    //     'Veuillez traitez tous les médicament ajoutés',
    //     'error'
    //   );
    //   return;
    // }

    Swal.fire({
      title: 'Soumission',
      text: 'Souhaitez-vous poursuivre cette action?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.saveItems();
      }
    });
  }

  saveItems() {
    this.isConsultationSuccess = false;

    let file_data = '';
    if (this.currentFile && Object.keys(this.currentFile).length) {
      file_data = this.currentFile;
    }
    console.log(
      'this.itemsPrescriptionAservir: ',
      this.itemsPrescriptionAservir,
    );
    let montant = 0;
    let part_patient = 0;
    let part_assurance = 0;
    // let ratio_depassement = this.itemToSave.montant_depassement / this.itemsPrescriptionAservir.length
    const totalPartAssuranceOriginal = this.getTotalPartAssurance();
    const partAssuranceAjustee =
      this.itemToSave.part_assurance ?? totalPartAssuranceOriginal;
    if (this.itemsPrescriptionAservir && this.itemsPrescriptionAservir.length) {
      this.itemsPrescriptionAservir.map((im: any) => {
        im.affection_id = this.itemToSave.affection_id;
        im.date_presription = this.itemToSave.date_presription;
        ((im.mode_prescription = this.itemToSave.mode_prescription),
          (im.matricule = this.itemBeneficiare.matricule),
          (im.beneficiaire_id = this.itemBeneficiare.id));
        // im.quantite = im.quantite_pharmacie
        ((im.prescription_acte_id = im.id),
          (im.quantite_vendue = im.quantite_pharmacie),
          (im.quantite_prescripte = im.quantite),
          (im.prix_unitaire_vente = im.prix_pharmacie),
          (im.prix_unitaire_systeme = im.prix_systeme),
          (im.prestataire_id = this.user.prestataire_id),
          // im.depassement = im.depassement + ratio_depassement;
          delete im.depassement);
        const ratio =
          totalPartAssuranceOriginal > 0
            ? (im.part_assurance || 0) / totalPartAssuranceOriginal
            : 0;
        im.part_assurance = Math.round(partAssuranceAjustee * ratio);
        im.part_patient = (im.montant || 0) - im.part_assurance;
        im.part_patient_net = im.part_patient;
        im.part_assurance_net = im.part_assurance;
        delete im.id;
        // montant +=im.montant
        // part_patient +=im.part_patient
        // part_assurance +=im.part_assurance
      });
    }

    const firstItem = this.itemsPrescriptionAservir[0] || {};
    const dataSinistre = {
      filiale_id: firstItem.filiale_id || this.user.filiale_id,
      beneficiaire_id: this.itemBeneficiare?.id,
      prestataire_id: this.user?.prestataire_id,
      matricule: this.itemBeneficiare?.matricule,
      police_id: firstItem.police_id,
      college_id: firstItem.college_id,
      souscripteur_id: firstItem.souscripteur_id,
      garant_id: firstItem.garant_id,
      garantie_id: firstItem.garantie_id,
      exercice_id: firstItem.exercice_id,
      taux_applicable: firstItem.taux_applicable,
      taux_couverture: firstItem.taux_couverture,
      montant: this.getTotal(),
      part_patient: this.itemToSave.part_patient ?? this.getTotalPartPatient(),
      part_assurance:
        this.itemToSave.part_assurance ?? this.getTotalPartAssurance(),
      depassement: this.itemsPrescriptionAservir.reduce(
        (s: number, im: any) => s + (im.depassement || 0),
        0,
      ),
      statut: 'ATTENTE_PREVALIDATION_PRESTATAIRE',
    };
    let request = {
      montant: this.getTotal(),
      part_patient: this.getTotalPartPatient(),
      part_assurance: this.getTotalPartAssurance(),
      dataSinistre,
      datas: [...this.itemsPrescriptionAservir],
    };

    this.restClient.post('prestationActe/create', request).subscribe(
      (res: any) => {
        // this.isLoading = false;
        if (res && !res['hasError']) {
          this.isConsultationSuccess = true;
          this.utilities.showSweetNotification(
            res['status']['message'],
            'succes',
          );
          // this.goNext()
          this.getItemsPrescriptionActe();
          // this.imprimerRecuVentePharmacie(res.item)
          this.itemToSave = {};
        } else {
          this.isConsultationSuccess = false;
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
        }
        this.onClosePrescriptionMedocModal.emit('hide');
      },
      (error) => {
        this.isConsultationSuccess = false;
        this.utilities.showSweetNotification(error, 'error');
      },
    );
  }

  addMedicament(): void {
    if (!this.selectedMedoc || this.selectedMedoc.is_entente_prealable) {
      this.utilities.showSweetNotification(
        'Veuillez choisir un médicament garanti svp',
        'error',
      );
      return;
    }
    if (!this.selectedMedoc || !this.selectedMedoc.id) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner le médicament',
        'error',
      );
      return;
    }
    if (!this.itemToAdd.quantite) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner la quantité',
        'error',
      );
      return;
    }
    if (!this.itemToAdd.posologie) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner la posologie',
        'error',
      );
      return;
    }
    if (!this.itemToAdd.duree) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner la durée',
        'error',
      );
      return;
    }
    if (!this.itemToAdd.prix) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner le prix',
        'error',
      );
      return;
    }
    // console.log("this.itemToAdd.prix: ",this.itemToAdd.prix)
    // console.log("this.medocOriginal: ",this.medocOriginal)
    if (this.itemToAdd.prix > this.medocOriginal.prix_systeme) {
      this.utilities.showSweetNotification(
        'Le prix du substitut doit etre inférieur ou égal au produit substitué: ' +
          this.medocOriginal.prix_systeme,
        'error',
      );
      return;
    }

    let obj = {
      college_id: this.medocOriginal.college_id,
      police_id: this.medocOriginal.police_id,
      ordonnance_id: this.medocOriginal.ordonnance_id,
      ordonnance_code: this.medocOriginal.ordonnance_code,
      bon_laboratoire_codification:
        this.medocOriginal.bon_laboratoire_codification,
      ordonnance_prestataire_id: this.medocOriginal.ordonnance_prestataire_id,
      prescription_pharmacie_id: this.medocOriginal.id,
      souscripteur_id: this.medocOriginal.souscripteur_id,
      garant_id: this.medocOriginal.garant_id,
      affection_id: this.medocOriginal.affection_id,
      prestation_id: this.medocOriginal.prestation_id,
      dossier_id: this.medocOriginal.dossier_id,
      prescription_pharmacie_replaced_id: this.medocOriginal.id,
      medicament_libelle: this.selectedMedoc.libelle,
      forme_medicament_libelle: this.selectedMedoc.forme_medicament_libelle,
      medicament_id: this.selectedMedoc.id,
      quantite: this.medocOriginal.quantite,
      duree: this.itemToAdd.quantite,
      posologie: this.itemToAdd.posologie,
      is_pending_validate: 0,
      is_entente_prealable: 0,
      is_exclu: 0,
      prix_systeme: this.itemToAdd.prix,
      prix_unitaire_systeme: this.itemToAdd.prix,
      is_replacer: true,
      prestataire_libelle: this.selectedMedoc.prestataire_libelle,
    };

    this.itemsPrescription.find((im: any) => {
      if (im.id == this.medocOriginal.id) {
        im.is_replaced = true;
      }
    });

    console.log('obj: ', obj);
    // this.itemsPrescription.unshift({ ...obj })
    this.itemsPrescription.push({ ...obj });

    // this.clearText = true
    // this.reload = !this.reload
    // this.itemToAdd = { quantite: 1 }
    this.showModal = false;
    this.groupItemsByCodification();

    console.log('items medoc after substitution: ', this.itemsPrescription);
  }

  onSelectMedoc(event: any) {
    console.log('current medoc', event);
    this.selectedMedoc = event || {};
  }

  goNext() {
    this.onGoToTab.emit('pharmacie');
  }

  addItemToList(item: any) {
    this.getTarifActe(item);
  }
  removeMedicamentFromList(item: any) {
    // item.is_added=true
    this.itemsPrescription.map((itm: any) => {
      if (itm.id == item.id) {
        itm.is_added = false;
      }
    });
    this.itemsPrescriptionAservir = this.itemsPrescription.filter(
      (itm: any) => itm.is_added == true,
    );
  }

  removeItem(index: number): void {
    if (confirm('Êtes-vous sûr de vouloir supprimer cet élément?')) {
      this.itemsPrescription.splice(index, 1);
    }
  }

  openSubstitutionModal(item: any) {
    this.medocOriginal = { ...item };
    this.selectedMedoc = {};
    this.itemToAdd = {};
    this.itemToAdd.quantite = this.medocOriginal.quantite;
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  // dialog() {
  //   this.simpleDialog = this.dialogModel.open(SimpleDialogComponent);
  // }
  // openDialog(): void {
  //   this.dialogModel.open(DialogformComponent, {
  //     width: '640px',
  //     disableClose: true,
  //   });
  // }

  openModal(content: any, item: any) {
    this.medocOriginal = { ...item };
  }

  reloadMedoc() {
    this.cancelItemSelected = false;
    setTimeout(() => {
      this.cancelItemSelected = true;
    }, 0);
  }

  onSelectMedocPro(event: any) {
    console.log('medoc substitue', event);
    console.log('medocOriginal', this.medocOriginal);
    this.selectedMedoc = { ...event };
    this.itemToAdd.prix = this.selectedMedoc.prix;
  }

  groupItemsByCodification() {
    this.groupedItemsPrescription = this.itemsPrescription.reduce(
      (
        acc: { [x: string]: any[] },
        item: { bon_laboratoire_codification: string },
      ) => {
        const key = item.bon_laboratoire_codification || 'Autres';
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      },
      {} as { [key: string]: any[] },
    );
  }

  canAdd(item: any): boolean {
    // return item.quantite > 0 && !item.is_added && !item.is_replaced;
    return !item.is_added && !item.is_exclu && !item.is_entente_prealable;
  }

  canSubstitute(item: any): boolean {
    return (
      item.quantite > 0 &&
      !item.is_added &&
      !item.is_replaced &&
      !item.is_replacer &&
      !item.is_exclu &&
      !item.is_entente_prealable
    );
  }

  //     onSetUserInfo(event:any){
  //   if(event.id){
  //     this.itemBeneficiare=event
  //     // this.getItemsPrescriptionActive()
  //   }

  // }

  onSetUserInfo(event: any) {
    if (event.id) {
      this.itemBeneficiare = event;
      this.authService.setActiveBeneficiaire(event);
      this.itemConsultation = {};
      this.beneficiaireAutOselect = this.itemBeneficiare;
      this.getItemsGarantie();
    } else {
      this.authService.setActiveBeneficiaire({});
      this.beneficiaireAutOselect = {};
    }
  }

  getItemsGarantie() {
    let request = {
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient.post('garantie/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsGarantie = res.items;
          console.log('this.itemsGarantie: ', this.itemsGarantie);
          this.getItemsPrescriptionActe();
          // this.getItemsActe()

          this.itemConsultation.raison_consultation_id =
            this.itemsGarantie[0].id;
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsGarantie = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsGarantie = [];
      },
    );
  }
  getItemsPrescriptionActe() {
    if (!this.itemsGarantie || !this.itemsGarantie.length) return;
    let garantie_id =
      this.itemsGarantie.find((ig: any) => ig.codification == 'AMP')?.id ??
      null;
    if (!garantie_id) {
      return;
    }
    if (!this.itemBeneficiare.id) {
      return;
    }
    this.groupedItemsPrescription = {};
    this.isLoading = true;
    this.itemsPrescriptionAservir = [];
    let request = {
      index: 0,
      // type_prescription: 'MEDICAMENT',
      is_medicament_classique: true,
      size: 1000,
      data: {
        beneficiaire_id: this.itemBeneficiare.id,
        garantie_id: garantie_id,
      },
    };

    this.restClient.post('prescriptionActe/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsPrescription = res.items;

          console.log('this.itemsPrescription: ', this.itemsPrescription);
          this.itemsPrescription = this.itemsPrescription.filter(
            (it: any) =>
              it.count_amp_non_hospit == 0 && !it.is_expired && !it.is_factured,
          );

          this.itemsPrescription.map((itm: any) => (itm.is_added = false));
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsPrescription = [];
        }
      },
      (error) => {
        this.isLoading = false;
        this.utilities.showSweetNotification(error, 'error');
        this.itemsPrescription = [];
      },
    );
  }

  getTarifActe(acte: any) {
    let request = {
      index: 0,
      size: 1000,
      data: {
        acte_id: acte.acte_id,
        matricule: this.itemBeneficiare.matricule,
        prestataire_codification: this.user.prestataire_codification,
        // garantie_id:garantie_id
      },
    };

    this.restClient.post('bareme/deepSeek', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['item']) {
          this.itemTarifActe = res.item;
          acte.is_added = true;
          acte.part_patient = this.itemTarifActe.part_patient;
          acte.message_depassement = this.itemTarifActe.message_depassement;
          acte.message_explicatif = this.itemTarifActe.message_explicatif;
          acte.depassement = this.itemTarifActe.depassement;
          // acte.part_patient=this.itemTarifActe.part_patient_net
          acte.montant = this.itemTarifActe.montant;
          acte.part_assurance = this.itemTarifActe.part_assurance;
          // acte.part_assurance=this.itemTarifActe.part_assurance_net
          acte.prestation_acte_id = this.itemTarifActe.prestation_acte_id;

          acte.code = this.generateUniqueString();
          acte.prix_unitaire = acte.montant;
          acte.prix_unitaire_accord = acte.montant;
          acte.taux_couverture = this.itemBeneficiare.taux_applicable;
          acte.taux_applicable = this.itemBeneficiare.taux_applicable;
          acte.quantite = 1;
          acte.quantite_accord = 1;
          acte.montant_remboursable = acte.montant;
          acte.montant_accorde = acte.part_assurance;
          acte.is_tpg = acte.is_tpg;
          acte.montant_tpg = acte.montant_tpg;
          acte.libelle = acte.libelle;
          acte.beneficiaire_id = this.itemBeneficiare.id;
          acte.matricule = this.itemBeneficiare.matricule;
          acte.matricule_assure = this.itemBeneficiare.matricule_assure;
          acte.prestataire_id = this.user.prestataire_id;
          acte.is_factured = false;
          acte.is_hospit = false;
          // acte.latitude = this.latitude
          // acte.longitude = this.longitude

          this.itemsPrescriptionAservir = this.itemsPrescription.filter(
            (itm: any) => itm.is_added == true,
          );
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemTarifActe = {};
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemConsultation = {
          raison_consultation_id: this.itemConsultation.raison_consultation_id,
          medecin_id: this.itemConsultation.medecin_id,
        };
        this.itemTarifActe = {};
      },
    );
  }

  onActeDeepSeek() {
    if (!this.itemsGarantie || !this.itemsGarantie.length) return;

    let garantie_id =
      this.itemsGarantie.find((ig: any) => ig.codification == 'AMP')?.id ??
      null;
    if (!garantie_id) {
      return;
    }

    if (
      !this.itemsPrescriptionAservir ||
      !this.itemsPrescriptionAservir.length
    ) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner au moin un acte',
        'error',
      );
      return;
    }

    let medicament_non_traite = this.itemsPrescriptionAservir.filter(
      (ima: any) => {
        return !ima.is_entente_prealable && !ima.is_exclu && !ima.montant;
      },
    );

    if (medicament_non_traite.length) {
      this.utilities.showSweetNotification(
        'Veuillez traitez tous les actes ajoutés',
        'error',
      );
      return;
    }
    this.itemToSave.montant_depassement = 0;
    this.itemToSave.message_depassement = 0;
    let request = {
      index: 0,
      size: 1000,
      data: {
        part_assurance: this.getTotalPartAssurance(),
        part_patient: this.getTotalPartPatient(),
        matricule: this.itemBeneficiare.matricule,
        garantie_id: garantie_id,
      },
    };

    this.restClient.post('bareme/deepSeekActe', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['item']) {
          let response = res['item'];

          if (
            response.montant_depassement &&
            response.montant_depassement > 0
          ) {
            this.itemToSave.montant_depassement = response.montant_depassement;
            this.itemToSave.message_depassement = response.message_depassement;
            this.itemToSave.part_patient = response.part_patient;
            this.itemToSave.part_assurance = response.part_assurance;
          } else {
            this.confirmSaveItem(this.itemToSave);
          }
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
        }
      },
      (error) => {
        this.isLoading = false;
        this.utilities.showSweetNotification(error, 'error');
      },
    );
  }

  showMessageDepassement(item: any) {
    Swal.fire({
      title: 'Alerte dépassement',
      text: item.message_depassement,
      icon: 'info',
      showCancelButton: false,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Fermer',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        // this.saveItems()
      }
    });
    // alert(item.message_depassement)
  }
  showMessageExplicatif(item: any) {
    if (!item.message_explicatif || !item.message_explicatif.length) return;
    Swal.fire({
      title: 'Message explicatif',
      text: item.message_explicatif,
      icon: 'info',
      showCancelButton: false,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Fermer',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        // this.saveItems()
      }
    });
    // alert(item.message_depassement)
  }

  openChatDialog(item: any): void {
    this.dialogModel.open(PrescriptionActeChatDialogComponent, {
      width: '60vw',
      maxWidth: '100vw',
      data: { item },
      autoFocus: false,
    });
  }

  onPrescriptionSaved() {
    this.showPresModal = false;
    this.getItemsPrescriptionActe();
  }
}
